import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { isImplicitRecoveryHash } from '../utils/authRecovery';

/** Anclas del diseño / inglés → id real en el DOM de la landing. */
const SECTION_ALIASES: Record<string, string> = {
  precio: 'precios',
  pricing: 'precios',
  price: 'precios',
  contact: 'contacto',
};

/** Incluye `#hero-dia` → `id="hero-dia"` en la sección `.inside` del hero nativo. */
function scrollToHashId(rawId: string) {
  const id = SECTION_ALIASES[rawId] || rawId;
  if (!id) return;
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

/**
 * En SPA, `/#seccion` no siempre hace scroll solo; alinear con la URL tras navegación interna.
 */
export function ScrollToHash() {
  const { pathname, hash } = useLocation();

  useLayoutEffect(() => {
    if (!hash || hash.length < 2) return undefined;
    if (isImplicitRecoveryHash(hash)) return undefined;
    const raw = decodeURIComponent(hash.replace(/^#/, '')).toLowerCase();
    const t = window.setTimeout(() => scrollToHashId(raw), 0);
    return () => clearTimeout(t);
  }, [pathname, hash]);

  return null;
}
